import { useQuery } from "react-query";
import { AUTH_USER } from "../constants";
import { orderMicroService } from "../services";
import { getUser } from "../helpers/helperMethods";

interface IGetFavoritesQueryParams {
  size: number;
  location_id?: number;
}

// Re-check the live auth state (same source the axios interceptor uses) at fetch
// time. This guards against a logout race where a fetch is queued with a stale
// userId after the token has already been cleared from localStorage.
const isLoggedOut = () => {
  const currentUser = getUser();
  return !currentUser?.id || currentUser?.logged_out;
};

const getFavorites = async (userId, location_id : number = null) => {
  if(!userId || isLoggedOut()) return [];
  const payload : IGetFavoritesQueryParams= { size: -1 }
  if( location_id) payload.location_id = location_id
  const response = await orderMicroService.getCustomerFavorites(userId,payload)
  return response.data.data.data;
};

export default function useFavorites(userId: number | null | undefined, userType: string = AUTH_USER, location_id: number = null) {
  return useQuery(["Favorites", userId, location_id], () => getFavorites(userId, location_id), {
    enabled: !!userId,
    retry: false,
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });
}
